/* eslint-disable import/prefer-default-export */
import { createSelector, createStructuredSelector } from 'reselect'

import { isMobileSelector } from 'reduxModules/app/selectors'

export const randomTestimonialSelector = (state) => state.testimonials.random
export const randomVideoTestimonialsSelector = (state) =>
  state.testimonials.videos
export const testimonialsSelector = (state) => state.testimonials.list

export const testimonialListSelector = createSelector(
  [testimonialsSelector, isMobileSelector],
  (testimonials, isMobile) => ({ testimonials, isMobile })
)

export default createStructuredSelector({
  random: randomTestimonialSelector,
  videos: randomVideoTestimonialsSelector
})
